import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { SMS_ENDPOINTS } from '../api/endpoints/sms.endpoints';

@Injectable({
  providedIn: 'root',
})
export class SmsService {
  private api = inject(ApiService);

  uploadFile(file): Observable<any> {
    return this.api.post(SMS_ENDPOINTS.V1.SEND_BULK_SMS, file);
  }
}
